<template>
  <div class="container">
    <div class="main">
      <!-- <div class="leftbannner"></div> -->
      <div class="rightlogin">
        <div class="top">
          <div class="logo">
            <img class="img1" src="../../assets/images/index_logo.png" alt="">
            <!-- <img class="img2" src="../../assets/images/index_logo3.png" alt=""> -->
          </div>
        </div>
        <div class="text gray-9 flex">
          —— 网络货物运输经营者专属平台 ——
        </div>
        <div class="bottom">
          <p class="title">
            <span class="max">注册</span>
            <span class="min" @click="utils.toUrl('/auth/login')">
              <i style="color:#fff;">已有账号?</i> 立即登录
            </span>
          </p>
          <el-form ref="form" :model="request" class="form" @submit.native.prevent>
            <el-form-item :rules="filter_rules(true,'phone')" prop="phone">
              <el-input class="aa" :autocomplete="off" v-model="request.phone" maxlength="11" placeholder="请输入手机号" clearable>
                <i slot="prefix" class="xy xy-icon25"></i>
              </el-input>
            </el-form-item>
            <el-form-item :rules="filter_rules(true,'number')" prop="key">
              <el-input :autocomplete="off" placeholder="请输入验证码" class="aa" maxlength="4" v-model="request.key" style="width:225px" clearable><i slot="prefix" class="xy xy-icon29" style="font-size:15px"></i></el-input>
              <el-button type="primary" style="height:48px;width:130px" v-show="!showBtn" @click="getCode">获取验证码</el-button>
              <el-button type="primary" v-show="showBtn" style="height:48px;width:120px" disabled>{{count}}秒后重新获取</el-button>
            </el-form-item>
            <el-form-item :rules="filter_rules(true,'pwd')" prop="fpassword">
              <el-input class="aa" ref="input1" v-model="request.fpassword" maxlength="16" placeholder="请输入密码" clearable>
                <i slot="prefix" class="xy xy-icon24"></i>
              </el-input>
            </el-form-item>
            <el-form-item :rules="filter_rules(true,'pwd')" prop="spassword">
              <el-input class="aa" ref="input2" v-model="request.spassword" maxlength="16" placeholder="请输入确认密码" clearable>
                <i slot="prefix" class="xy xy-icon24"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="rember">
              <el-checkbox v-model="checked">已同意并阅</el-checkbox>
              <a href="#" style="color:#409eff;">平台协议</a>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="loginBtn" native-type="submit" :disabled="!checked" @click="login('form')">立即注册</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      off: 'off',
      showBtn: false,
      count: "60",
      checked: true,
      request: {
        fpassword: null,
        is_agree: true,
        key: null,
        phone: null,
        spassword: null
      }
    };
  },
  mounted () {
    setTimeout(() => {
      this.$refs.input1.type = 'password'
      this.$refs.input2.type = 'password'
    }, 500);
  },
  methods: {
    getCode () {
      let reg = /^1(2|3|4|5|6|7|8|9)\d{9}$/;
      if (!this.request.phone) {
        alert("请输入手机号");
      } else if (reg.test(this.request.phone)) {
        if (this.count <= 0 || this.count == 60) {
          this.api(150103, {
            phone: this.request.phone,
            msg_type: "REGISTER_LOGIN"
          }).then(res => {
            if (this.utils.isSuccess(res)) {
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.showBtn = true;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.showBtn = false;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000);
              }
            } else {
              alert(res.biz_msg)
            }
          });
        }
      } else {
        alert("手机号有误");
      }
    },
    login (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checked ? this.request.is_agree = 'YES' : this.request.is_agree = 'NO';
          // let Base64 = require("js-base64").Base64;
          // this.request.fpassword = Base64.encode(this.request.fpassword)
          // this.request.spassword = Base64.encode(this.request.spassword)
          this.api(150102, this.request).then(res => {
            let data;
            alert(res.biz_msg)
            if ((data = this.utils.isSuccess(res))) {
              this.utils.toUrl('/auth/login');
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
$bgimg: "https://website-mp4.obs.cn-north-4.myhuaweicloud.com:443/1642124173559.png";
.container {
  width: 100%;
  height: 100%;
  // background: #f5f5f5;
  background: url($bgimg) no-repeat;
  background-size: 100%;
  position: relative;
  .main {
    width: 559px;
    height: 604px;
    position: absolute;
    right: 5%;
    top: 15%;
    // overflow: hidden;
    // background: #fff;
    // display: flex;
    // align-items: center;
    .leftbannner {
      display: inline-block;
      width: 636px;
      height: 604px;
      background: url(../../assets/images/login_img.png) no-repeat;
    }
    .rightlogin {
      width: 559px;
      height: 604px;
      background-color: rgba(151, 147, 144, 0.5);
      .text {
        justify-content: center;
        font-size: 16px;
        color: #fff;
      }
      .top {
        padding-top: 30px;
        .logo {
          width: 100%;
          // height: 84px;
          display: flex;
          justify-content: center;
          // background: url(../../assets/images/index_logo.png) no-repeat;
          // margin: 0 auto;
          .img1 {
            position: relative;
            left: -11px;
          }
          .img2 {
            height: 35px;
            position: relative;
            top: 20px;
            left: 11px;
          }
        }
      }
      .bottom {
        padding: 60px 100px;
        padding-top: 30px;
        .title {
          margin: 0;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 361px;
          .max {
            font-size: 20px;
            color: #fff;
          }
          .min {
            font-size: 14px;
            color: #409eff;
            cursor: pointer;
          }
        }
        .form {
          width: 361px;
          .loginBtn {
            width: 100%;
            height: 48px;
            font-size: 20px;
          }
        }
        .register {
          padding-left: 10px;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
        .register:hover {
          color: #409eff;
        }
      }
    }
  }
  .el-checkbox {
    margin-right: 5px;
  }
}
.el-form-item {
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/register.vue